import { logout } from './auth.service';

let inactivityTimer = null;
let eventListenersActive = false;
let lastActivityTime = Date.now();
const INACTIVITY_TIMEOUT = 120 * 60 * 1000; // 120 minutes in milliseconds
const THROTTLE_TIME = 5000; // Only check activity every 5 seconds

/**
 * Initialize inactivity timeout handler
 * Logs out user if inactive for the specified duration
 */
export const initInactivityTimer = () => {
  // Clear existing timer if any
  clearInactivityTimer();

  // Only set timer if user is logged in (has authToken)
  if (localStorage.getItem('authToken')) {
    lastActivityTime = Date.now();
    resetInactivityTimer();
    if (!eventListenersActive) {
      setupEventListeners();
    }
  }
};

/**
 * Activity handler - throttled to prevent excessive calls
 */
const handleActivity = () => {
  const now = Date.now();
  // Only reset timer if enough time has passed since last activity
  if (now - lastActivityTime > THROTTLE_TIME) {
    lastActivityTime = now;
    resetInactivityTimer();
  }
};

/**
 * Reset the inactivity timer
 */
export const resetInactivityTimer = () => {
  clearTimeout(inactivityTimer);

  inactivityTimer = setTimeout(async () => {
    // Time's up! Log out the user
    try {
      await logout();
      console.log('User automatically logged out due to inactivity');
    } catch (error) {
      console.error('Error during auto logout:', error);
      // Clear auth data anyway
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    }
    
    // Redirect to login
    window.location.href = '/login';
  }, INACTIVITY_TIMEOUT);
};

/**
 * Clear the inactivity timer
 */
export const clearInactivityTimer = () => {
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
    inactivityTimer = null;
  }
};

/**
 * Setup event listeners to reset timer on user activity
 */
const setupEventListeners = () => {
  const events = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
    'keydown'
  ];

  events.forEach(event => {
    document.addEventListener(event, handleActivity, true);
  });
  
  eventListenersActive = true;
};

/**
 * Cleanup event listeners when logging out
 */
export const cleanupInactivityTimer = () => {
  clearInactivityTimer();

  if (eventListenersActive) {
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click',
      'keydown'
    ];

    events.forEach(event => {
      document.removeEventListener(event, handleActivity, true);
    });
    
    eventListenersActive = false;
  }
};
